import { render, staticRenderFns } from "./TelecomsDealForm.vue?vue&type=template&id=dfb1a8ba&scoped=true&"
import script from "./TelecomsDealForm.vue?vue&type=script&lang=js&"
export * from "./TelecomsDealForm.vue?vue&type=script&lang=js&"
import style0 from "./TelecomsDealForm.vue?vue&type=style&index=0&id=dfb1a8ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfb1a8ba",
  null
  
)

export default component.exports